import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';

// Define the shape of the props
interface SliderProps {
  images?: string[]; // Array of image URLs
}

function Slider({ images }: SliderProps) {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  // Fallback if no images are provided by the API
  const displayImages = images && images.length > 0 
    ? images 
    : ["assets/img/portfolio/branding-1.jpg"]; // Default placeholder

  return (
    <Carousel 
      activeIndex={index} 
      onSelect={handleSelect} 
      variant="dark" 
      className="service-slider shadow-sm rounded overflow-hidden"
    >
      {displayImages.map((src, idx) => (
        <Carousel.Item key={idx}>
          <img
            className="d-block w-100 object-fit-cover"
            src={src}
            alt={`Slide ${idx + 1}`}
            style={{ height: '400px' }} // Standardized height for the details page
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default Slider;